import { ReactComponent as Chat } from 'images/chat.svg';
import { Trans, useTranslation } from 'react-i18next';
import { PortalComponent } from '../PortalComponent';
import s from './AppStartupLoader.module.css';

export const AppStartupLoader = () => {
  const { t, i18n } = useTranslation();

  return (
    <PortalComponent>
      <div className={s['app-startup-loader']} role='status' aria-busy='true'>
        <p className={s['app-startup-loader__greeting']}>
          <Trans
            key={i18n.resolvedLanguage}
            t={t}
            i18nKey='chat.welcome_startup'
            components={[
              <span
                key='left'
                className={s['app-startup-loader__text_left']}
              />,
              <Chat
                key='icon'
                className={s['app-startup-loader__icon']}
                aria-hidden='true'
              />,
              <span
                key='right'
                className={s['app-startup-loader__text_right']}
              />,
            ]}
          />
        </p>
      </div>
    </PortalComponent>
  );
};
